import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorBoundary } from 'wsm-error-boundary';
import loadShift from '../utils/loadShift';
import '../utils/swipingDirection';

import DataMapper from '../components/DataMapper';

let timeout;

/**
 *
 * @returns get the type of the page, currently used to load page specific mappings, can be built out further in the future
 */
const getPageType = () => {
	let pageType = '';
	if (typeof window !== 'undefined') {
		const { isVdp, isVlp } = window?.DDC?.dataLayer?.page?.pageInfo || {};
		if (isVdp) {
			pageType = 'vdp';
		} else if (isVlp) {
			pageType = 'srp';
		}
	}
	return pageType;
};

export class WidgetContainer extends React.Component {
	componentDidMount() {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tagging'] =
			window.DDC.WidgetData['ws-tagging'] || {};
		window.DDC.WidgetData['ws-tagging'].mapping = this.props.mapping;
		window.dispatchEvent(new Event('ws-tagging-ready'));
	}

	componentWillUnmount() {
		clearTimeout(timeout); // added to pass a unit test but also makes sure setState doesn't run when component unmounted
		delete window.DataLayerHelper;
	}

	render() {
		let component;
		if (typeof window !== 'undefined' && window?.DDC?.isComposer) {
			component = null;
		} else {
			if (this.props.mapping.shiftnative) {
				const { liveScriptLocation, defaultScriptLocation, clientId } =
					this.props.mapping.shiftnative.configuration;

				loadShift({
					liveScriptLocation,
					defaultScriptLocation,
					clientId
				});
			}

			component = (
				<ErrorBoundary newRelicPageAction="ws-tagging error boundary">
					<div data-testid="Widget">
						<DataMapper
							mapping={this.props.mapping}
							pageAlias={this.props.pageAlias}
							pageType={getPageType()}
						/>
					</div>
				</ErrorBoundary>
			);
		}
		return component;
	}
}

WidgetContainer.propTypes = {
	mapping: PropTypes.shape({
		shiftnative: PropTypes.shape({
			configuration: PropTypes.shape({
				liveScriptLocation: PropTypes.string,
				defaultScriptLocation: PropTypes.string,
				clientId: PropTypes.string
			})
		})
	}),
	pageAlias: PropTypes.string
};

const mapStateToProps = ({ mapping, widgetInfo: { pageAlias } }) => ({
	mapping,
	pageAlias
});

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
